/**
 * Semantic status tokens — pipeline stages, payments, sync health.
 * Matches M3 Pearl theme spec (Confirmed, Awaiting deposit, In progress, Overdue).
 */

const statusTokens = {
  success: {
    background: "#D7F0E0",
    text: "#1F8A56",
    dot: "#1F8A56",
  },
  warning: {
    background: "#FFDDB3",
    text: "#8A5300",
    dot: "#E68A06",
  },
  info: {
    background: "#D6E3FF",
    text: "#1565C8",
    dot: "#1565C8",
  },
  error: {
    background: "#FFDAD6",
    text: "#BA1A1A",
    dot: "#BA1A1A",
  },
  neutral: {
    background: "#ECF1F8",
    text: "#545F71",
    dot: "#717C96",
  },
};

const STATUS_ALIASES = {
  confirmed: "success",
  "booking confirmed": "success",
  booked: "success",
  active: "success",
  qualified: "success",
  success: "success",
  completed: "success",
  delivered: "success",
  paid: "success",
  secured: "info",

  "awaiting deposit": "warning",
  "deposit due": "warning",
  "payment pending": "warning",
  "awaiting payment": "warning",
  "pending payment": "warning",
  quoting: "warning",
  pending: "warning",
  warning: "warning",
  hot: "warning",

  "in progress": "info",
  progress: "info",
  processing: "info",
  open: "info",

  overdue: "error",
  inactive: "error",
  error: "error",
  disqualified: "error",
  cancelled: "error",
  canceled: "error",
  failed: "error",
  declined: "error",
  refunded: "error",

  draft: "neutral",
  new: "info",
  sent: "info",
  unknown: "neutral",

  // Call center. callStates.js declares a `status` per call state on the
  // assumption these exist; without them every call badge in the console and
  // the wallboard resolved to "neutral" and rendered grey, regardless of the
  // accent colour defined alongside it.
  ringing: "info",
  connecting: "info",
  connected: "success",
  "on hold": "warning",
  "wrap up": "info",
  "on call": "success",
  offline: "neutral",
  // The four "away" presences. All warning rather than neutral: an agent on
  // lunch is a reason a queue is not answering, which a supervisor scanning
  // the wallboard needs to see, not a grey absence of information.
  break: "warning",
  lunch: "warning",
  meeting: "warning",
  training: "warning",
  queued: "info",
  abandoned: "error",
  voicemail: "warning",
  busy: "warning",

  // Merchant asset inventory
  available: "success",
  "sold out": "error",
  unavailable: "warning",
  empty: "neutral",
  "partially booked": "warning",
  "fully booked": "error",
};

export const resolveStatusVariant = (status) => {
  const key = (status || "draft").toString().trim().toLowerCase().replace(/_/g, " ");
  return STATUS_ALIASES[key] || "neutral";
};

export const getStatusTokens = (status) => {
  const variant = resolveStatusVariant(status);
  return { variant, ...statusTokens[variant] };
};

export default statusTokens;
